import {
    IProvidedFilter,
    TextFilterModel,
    SetFilterModel,
    IMultiFilterModel,
    KeyCreatorParams,
    ValueFormatterParams,
} from 'ag-grid-community';

import {customStringConvertionFilter} from '../components/grid';
import { Categories, Departments, ResponseViewFiles } from 'tilby-models';

type CustomFilterType = 'data' | 'text' | 'set' | number | 'multi';

export interface CustomUIFilter {
    type: CustomFilterType;
    sortable:boolean;
    filterable:boolean;

    getUIFilter(params?:any):any;

    // getUIFilterValue(params);

    // Restituisce stringa per x_query
    getConversionFilter(params:any&IProvidedFilter):string;

    // Restituisce un oggetto per query piatte (es. { category_id: 35 })
    getConversionFilterObject?(params: any): Record<string, any>;
}

type DocumentCustomValue = '0_RECEIPT' | '1_INVOICE' | '2_STORED_SALE' | '3_OTHER';

export class TypeDocumentFilter implements CustomUIFilter {
    type: CustomFilterType = 'set';
    sortable = false;
    filterable = true;

    constructor(
        private showStoredSales: boolean = false
    ) {
    }

    getUIFilter() {
        return {
            values: (params: any): DocumentCustomValue[] => {
                return this.showStoredSales
                    ? params.success(['0_RECEIPT', '1_INVOICE', '2_STORED_SALE', '3_OTHER'])
                    : params.success(['0_RECEIPT', '1_INVOICE', '3_OTHER']);
            }
        }
    }

    private getDocumentsToFilter(value: DocumentCustomValue | string | null) {
        switch (value) {
            case '0_RECEIPT':
                return ['fiscal_receipt', 'commercial_doc', 'refund_doc', 'void_doc', 'generic_receipt'];
            case '1_INVOICE':
                return ['invoice', 'receipt_invoice', 'summary_invoice', 'credit_note', 'shipping_invoice', 'e_invoice', 'summary_e_rc', 'summary_e_nrc', 'generic_invoice'];
            case '2_STORED_SALE':
                return ['stored_sale'];
            case '3_OTHER':
                return ['generic_document'];
            default:
                return [];
        }
    }

    getConversionFilter(params: SetFilterModel) {
        const documentsToFilter: string[] = [];
        const isStoredSale = params.values.includes('2_STORED_SALE');

        for (const value of params.values) {
            if (value !== '2_STORED_SALE') {
                documentsToFilter.push(...this.getDocumentsToFilter(value));
            }
        }

        const query: string[] = [];

        if(documentsToFilter.length) {
            query.push(`sale_documents.document_type_in=(${documentsToFilter.join(',')})`);
        }

        if (isStoredSale) {
            query.push(`status=stored`);
        }

        return query.length
            ? `OR(${query.join(',')})`
            : ''
    }
}

export class CustomerNameFilter implements CustomUIFilter {
    type: CustomFilterType = 'text';
    sortable = false;
    filterable = true;
    constructor() {
    }

    getUIFilter() {
    };

    getConversionFilter(params: TextFilterModel) {
        let query = '';

        const {prefix, x_queryPrefix, inputFilter} = customStringConvertionFilter(params,'AND');
        const inputFilterNoDashes = inputFilter.replace(/-/g, ' ');
        inputFilterNoDashes.split(/ +/g).forEach((value: string) => {
            query = query.concat(`,OR(sale_customer.first_name${prefix}=${value},sale_customer.last_name${prefix}=${value},sale_customer.company_name${prefix}=${value})`);
        });
        query = query.replace(',', '');
        return `${x_queryPrefix}(${query})`;
    }
}

export class EInvoiceNumberFilter implements CustomUIFilter {
    type: CustomFilterType = 'text';
    sortable = false;
    filterable = true;

    constructor() {}

    getUIFilter() {}

    getConversionFilter(params: TextFilterModel) {
        let query = '';

        const { prefix, x_queryPrefix, inputFilter } = customStringConvertionFilter(params, 'AND');
        const cleanInput = inputFilter.trim();
        cleanInput.split(/ +/g).forEach((value: string) => {
            query = query.concat(
                `,OR(` +
                    `sale_documents.sequential_number_prefix${prefix}=${value},` +
                    `sale_documents.sequential_number${prefix}=${value}` +
                `)`
            );
        });

        query = query.replace(',', '');
        return `${x_queryPrefix}(${query})`;
    }
}

export class PrinterNameFilter implements CustomUIFilter {
    type: CustomFilterType = 'text';
    sortable = false;
    filterable = true;
    constructor() {
    }

    getUIFilter() {
    };

    getConversionFilter(params: TextFilterModel) {
        const {prefix, x_queryPrefix, inputFilter} = customStringConvertionFilter(params,'OR');
        const query = `sale_documents.printer_name${prefix}=${inputFilter}`;
        return `${x_queryPrefix}(${query})`;
    }
}
export class AmountPrepaidFilter implements CustomUIFilter {
    type: CustomFilterType = 0;
    sortable = false;
    filterable = false;
    constructor() {
    }

    getUIFilter() {
    };

    getConversionFilter(params: TextFilterModel) {
        return ``;
    }
}

export class PaymentTypeFilter implements CustomUIFilter {
    type: CustomFilterType = 'text';
    sortable = false;
    filterable = true;
    constructor() {
        // console.log("constructor PaymentTypeFilter")
    }

    getUIFilter() {
    };

    getConversionFilter(params: TextFilterModel) {
        // console.log("getConversionFilter PaymentTypeFilter ", params)
        let query = '';

        const {prefix, x_queryPrefix, inputFilter} = customStringConvertionFilter(params,'AND');
        // console.log("prefix: ", prefix, " x_queryPrefix: ", x_queryPrefix, " inputFilter: ", inputFilter);
        const inputFilterNoDashes = inputFilter.replace(/-/g, ' ');
        // console.log("inputFilterNoDashes ", inputFilterNoDashes);
        inputFilterNoDashes.split(/ +/g).forEach((value: string) => {
            // console.log("value ", value);
            query = query.concat(`,OR(payments.payment_method_name${prefix}=${value})`);
            // console.log("query ", query);
        });
        query = query.replace(',', '');
        // console.log("Final query ", query);
        // console.log("RESULT: ", `${x_queryPrefix}(${query})`)
        return `${x_queryPrefix}(${query})`;
    }
}

export class SequentialNumberFilter implements CustomUIFilter {
    type: CustomFilterType = 'text';
    sortable = false;
    filterable = true;
    constructor() {
    }

    getUIFilter() {
    };

    getConversionFilter(params: TextFilterModel) {
        let query = '';

        const {prefix, x_queryPrefix, inputFilter} = customStringConvertionFilter(params,'AND');
        const inputFilterNoDashes = inputFilter.replace(/-/g, ' ');
        inputFilterNoDashes.split(/ +/g).forEach((value: string) => {
            query = query.concat(`,OR(sale_documents.sequential_number${prefix}=${value})`);
        });
        query = query.replace(',', '');
        return `${x_queryPrefix}(${query})`;
    }
}

type TypeCashMovementCustomValue = 'income' | 'outcome';

export class TypeCashMovementFilter implements CustomUIFilter {
    type: CustomFilterType = 'set';
    sortable = false;
    filterable = true;
    static typeCashMovementValues: TypeCashMovementCustomValue[] = ['income', 'outcome'];

    constructor() {
    }

    getUIFilter() {
        return {
            values: (params: any) => params.success(TypeCashMovementFilter.typeCashMovementValues)
        }
    }

    getConversionFilter(params: SetFilterModel) {
        let query = '';

        params.values.forEach((value: string|TypeCashMovementCustomValue|null) => {
            switch (value) {
                case 'income':
                    query = query.concat(`,type=income`);
                    break;
                case 'outcome':
                    query = query.concat(`,type=outcome`);
                    break;
            }
        });
        query = query.replace(',', '');
        return `OR(${query})`;
    }
}

type AccountCashMovementCustomValue = 'cash' | 'other';

export class AccountCashMovementFilter implements CustomUIFilter {
    type: CustomFilterType = 'set';
    sortable = false;
    filterable = true;
    static accountCashMovementValues: AccountCashMovementCustomValue[] = ['cash', 'other'];

    constructor() {
    }

    getUIFilter() {
        return {
            values: (params: any) => params.success(AccountCashMovementFilter.accountCashMovementValues)
        }
    }

    getConversionFilter(params: SetFilterModel) {
        let query = '';

        params.values.forEach((value: string|AccountCashMovementCustomValue|null) => {
            switch (value) {
                case 'cash':
                    query = query.concat(`,account=cash`);
                    break;
                case 'other':
                    query = query.concat(`,account=other`);
                    break;
            }
        });
        query = query.replace(',', '');
        return `OR(${query})`;
    }
}

type StockAvailabilityCustomValue = 'available' | 'unavailable' | 'alert';

export class StockAvailabilityFilter implements CustomUIFilter {
    type: CustomFilterType = 'set';
    sortable = false;
    filterable = true;
    static stockAvailabilityValues: StockAvailabilityCustomValue[] = ['available', 'unavailable', 'alert'];

    getUIFilter() {
        return {
            values: (params: any) => params.success(StockAvailabilityFilter.stockAvailabilityValues)
        }
    }

    getConversionFilter(params: SetFilterModel) {
        const query: string[] = [];

        params.values.forEach((value: string | null) => {
            switch (value) {
                case 'available':
                    query.push(`available=${value}`, `available=producible`);
                    break;
                case 'unavailable':
                case 'alert':
                    query.push(`available=${value}`);
                    break;
            }
        });

        switch (query.length) {
            case 0:
                return '';
            case 1:
                return query[0];
            default:
                return `OR(${query.join(',')})`;
        }
    }
}

export class ResponseViewFilesStatusFilter implements CustomUIFilter {
    type: CustomFilterType = 'set';
    sortable = false;
    filterable = true;
    static responseViewFilesStatus: ResponseViewFiles.StatusEnum[] = ["completed", "loading", "processed", "created"];

    getUIFilter() {
        return {
            values: (params: any) => params.success(ResponseViewFilesStatusFilter.responseViewFilesStatus)
        }
    }

    getConversionFilter(params: TextFilterModel) {
        return ``;
    }
}

export class ItemCategoryNameFilter implements CustomUIFilter {

    type: CustomFilterType = 'set';
    sortable = false;
    filterable = true;

    getUIFilter(params: any) {
        // console.log("getUIFilter ItemCategoryNameFilter -> ", params)

        return {
            values: (p: any) => {
                const categories = p.context?.componentParent?.itemDataCatalogService?.getDataByKey("categories") ?? [];
                p.success(categories.map((c: Categories) => c.name));
            }
        }
    }

    getConversionFilter(params: SetFilterModel) {
        return ``;
    }
}
export class ItemCategoryNameMultiFilter implements CustomUIFilter {

    type: CustomFilterType = 'multi';
    sortable = false;
    filterable = true;

    getUIFilter(params?: any) {
        // console.log("getUIFilter ItemCategoryNameMultiFilter -> ", params)
        // console.log("Service: ", params?.context?.componentParent?.itemDataCatalogService)
        return [
            {
                filter: 'agTextColumnFilter',
                filterParams: {
                    maxNumConditions: 1
                },
            },
            {
                filter: 'agSetColumnFilter',
                displayName: "Select from list",
                filterParams: { 
                    refreshValuesOnOpen: true,
                    values: (params: any) => {
                        // console.log("Categories values: ", params?.context)
                        if (!params || !params.context || !params.context.extras) {
                            return params.success([]); 
                        }

                        const service = params.context.extras.itemDataCatalogService;
                        if (!service) return params.success([]);

                        const allData = params.context.extras.allData || false;
                        let categories: Categories[] = [];
                        
                        try {
                            if(allData) {
                                categories = service.getExtendedCategories() ?? [];
                            } else {
                                categories = service.getFilteredDataByKey("categories") ?? [];
                            }
                        } catch (e) {
                            // console.error("Errore durante il recupero categorie");
                            return params.success([]);
                        }

                        return params.success(categories);
                    },
                    keyCreator: (params: KeyCreatorParams) => {
                        // console.log("Categories keyCreator ", params.value)
                        const val = params.value;
                        if (val === null || val === undefined) return null;
                        if (typeof val !== 'object') return val.toString();
                        return val.id !== 0 && val.id !== '0'? val.id?.toString(): null;
                    },
                    valueFormatter: (params: ValueFormatterParams) => {
                        // console.log("Categories valueFormatter: ", params.value)
                        const val = params.value;

                        if (val === null || val === undefined) return '';
                        if (val && typeof val === 'object') {
                            return val.name || '';
                        }
                        const service = params.context?.extras?.itemDataCatalogService;
                        if (!service) return val.toString();

                        const categories = service?.getExtendedCategories() ?? [];
                        const found = categories.find((c: any) => c.id == val);
                        return found ? found.name : val;
                    } 
                }
            }
        ]
    }

    getConversionFilter(params: IMultiFilterModel) {
        // console.log("getConversionFilter ItemCategoryNameMultiFilter ", params)
        const allConditions: string[] = [];
        if(params.filterModels) {
            params.filterModels.forEach(model => {
                if(model?.filterType === 'text') {
                    const {prefix, x_queryPrefix, inputFilter} = customStringConvertionFilter(model,'AND');
                    const inputFilterNoDashes = inputFilter.replace(/-/g, ' ');
                    const textParts = inputFilterNoDashes.split(/ +/g).map((value: string) => {
                        return `OR(category.name${prefix}=${value})`;
                    });

                    if (textParts.length > 0) {
                        allConditions.push(`${x_queryPrefix}(${textParts.join(',')})`);
                    }
                }
                else if(model?.filterType === 'set' && model.values?.length) {
                    model.values.forEach((value: string | null) => {
                        allConditions.push(`category.id=${value}`);
                    });
                }
            })
        }
        const finalQuery = allConditions.join(',');
        return `OR(${finalQuery})`;
    }

    getConversionFilterObject(params: IMultiFilterModel): Record<string, any> {
        const filters: Record<string, any> = {};

        params.filterModels?.forEach(model => {
            if (model?.filterType === 'set' && model.values?.length) {
                const mappedValues = model.values.map((v: any) => !v ? 'null' : v);
                filters['category_id_in'] = mappedValues.join(',');
            }
            if (model?.filterType === 'text' && model.filter) {
                filters['category.name_like'] = model.filter;
            }
        });

        return filters;
    }
}

export class ItemDepartmentNameFilter implements CustomUIFilter {

    type: CustomFilterType = 'set';
    sortable = false;
    filterable = true;
    number: string;

    constructor(number: number = 0) {
        // console.log("constructor ItemDepartmentNameFilter ", number)
        this.number = number? number.toString(): '';
    }

    getUIFilter(params: any) {
        // console.log("getUIFilter ItemDepartmentNameFilter -> ", params)
        return {
            refreshValuesOnOpen: true,

            values: (params: any) => {
                // console.log("Departments values: ", params)
                const allData = params?.context?.extras?.allData || false;
                let departments: Departments[] = [];
                if(allData) {
                    departments = params?.context?.extras?.itemDataCatalogService?.getDataByKey("departments") ?? [];
                } else {
                    departments = params?.context?.extras?.itemDataCatalogService?.getFilteredDataByKey("departments") ?? [];
                }
                return params.success(departments);
            },
            keyCreator: (params: KeyCreatorParams) => {
                // console.log("Departments keyCreator ", params)
                const val = params.value;
                if (val === null || val === undefined) return null;
                if (typeof val !== 'object') return val.toString();
                return val.id !== 0 && val.id !== '0'? val.id.toString(): null;
            },
            valueFormatter: (params: ValueFormatterParams) => {
                // console.log("Departments valueFormatter: ", params)
                const val = params.value;

                if (val === null || val === undefined) return '';
                if (val && typeof val === 'object') {
                    return val.name;
                }
                const service = params.context?.extras?.itemDataCatalogService;
                const departments = service?.getDataByKey("departments") ?? [];
                const found = departments.find((c: any) => c.id == val);
                return found ? found.name : val;
            }
        };
    }

    getConversionFilter(params: SetFilterModel) {
        const queryParts = params.values.map(value => `department_id=${value}`);
        return `OR(${queryParts.join(',')})`;
    }

    getConversionFilterObject(params: SetFilterModel): Record<string, any> {
        if (!params.values || params.values.length === 0) return {};
        return {
            'department_id_in': params.values.map(v => v === null ? 'null' : v).join(',')
        };
    }
}

export class BarcodeFilter implements CustomUIFilter {
    type: CustomFilterType = 'text';
    sortable = false;
    filterable = true;

    getUIFilter() {
    };

    getConversionFilter(params: TextFilterModel) {
        // console.log("getConversionFilter BarcodeFilter ", params)
        const {prefix, x_queryPrefix, inputFilter} = customStringConvertionFilter(params,'AND');
        const inputFilterNoDashes = inputFilter.replace(/-/g, ' ');

        const values = inputFilterNoDashes.split(/ +/g).filter(v => v.trim() !== '');

        const queryParts = values.map(value => `OR(barcodes.barcode${prefix}=${value})`);
        const query = queryParts.join(',');

        return `${x_queryPrefix}(${query})`;
    }
}
